import type { components } from '@joyful/openapi/types.gen'
import {
  StrictSet,
  UserCapabilitySchema,
  createNonNullableContext,
} from '@joyful/utils'
import type { UserCapability } from '@joyful/utils'
import type { FeatureFlag } from './featureFlags'

type CurrentUserRead = components['schemas']['CurrentUserRead']

export type CurrentUserContextValue = {
  [Property in keyof CurrentUserRead]: Property extends 'capabilities'
    ? StrictSet<UserCapability>
    : Property extends 'feature_flags'
      ? StrictSet<FeatureFlag>
      : CurrentUserRead[Property]
}

export const CurrentUserContext =
  createNonNullableContext<CurrentUserContextValue>('CurrentUserContext')

export const useCurrentUser = CurrentUserContext.useRequiredContext

export function prepareCurrentUserData(
  currentUserData: components['schemas']['CurrentUserRead'],
): CurrentUserContextValue {
  const capabilities = new StrictSet<UserCapability>(
    currentUserData.capabilities.filter(
      (capability): capability is UserCapability => {
        const isKnownCapability = UserCapabilitySchema.validate(capability)
        if (!isKnownCapability) {
          console.warn(`Unrecognized capability: ${capability}`)
        }

        return isKnownCapability
      },
    ),
  )
  const featureFlags = new StrictSet<FeatureFlag>(currentUserData.feature_flags)

  return {
    ...currentUserData,
    capabilities,
    feature_flags: featureFlags,
  }
}
